/**
 * 域名测试辅助工具
 * 在开发环境中模拟不同域名
 */

// 扩展Window接口
declare global {
  interface Window {
    MOCK_HOSTNAME: string | null;
  }
}

// 存储模拟的域名
let mockHostname: string | null = null;

// 在URL中添加参数?domain=huiya可以模拟绘芽域名
export function setupDomainTesting(): void {
  // 仅在开发环境使用
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  console.log('======= 域名测试工具初始化 =======');
  console.log('真实域名:', window.location.hostname);
  console.log('URL参数:', window.location.search);

  // 获取URL参数
  const urlParams = new URLSearchParams(window.location.search);
  const domainParam = urlParams.get('domain');

  console.log('domain参数值:', domainParam);

  // 根据参数设置模拟域名
  if (domainParam === 'huiya') {
    mockHostname = 'huiyabook.cn';
    console.log('域名模拟成功: 当前使用绘芽域名 huiyabook.cn');
  } else if (domainParam === 'deerbook') {
    mockHostname = 'deerbook.cn';
    console.log('域名模拟成功: 当前使用奇鹿域名 deerbook.cn');
  } else {
    console.log('未指定域名参数，使用真实域名:', window.location.hostname);
  }
}

// 获取当前主机名（真实或模拟）
export function getHostname(): string {
  // 优先使用全局变量中的模拟域名
  if (window.MOCK_HOSTNAME) {
    console.log('getHostname() 使用全局模拟域名:', window.MOCK_HOSTNAME);
    return window.MOCK_HOSTNAME;
  }
  
  // 其次使用本地模拟域名
  const hostname = mockHostname || window.location.hostname;
  console.log('getHostname() 返回:', hostname);
  return hostname;
} 